
<!--<app-alerts></app-alerts>-->
<main>
  <section>
    <div class="container-fluid ptb-42">
      <div class="row">
        <div class="col-auto">
          <div class="titles-bdr-r">
            <h1 class="color-primary fs-325remTitles">{{faqStaticInfo.Titulo_Pagina}}</h1>
          </div>
        </div>
      </div>
    </div>
  </section>
  <section>
    <div class="container pb-120 gx-5 gx-lg-0 faqPage">
      <div class="row justify-content-center">
        <div class="col-lg-8 col-12">
          <form [formGroup]="searchForm" *ngIf="searchForm">
            <div class="search-container mb-5">
              <input type="text" formControlName="text" class="form-control search-input" placeholder="{{'formPlaceholders.pesquisa' | translate}}">
              <i class="uil uil-search fs-20px search-icon"></i>
            </div>
          </form>
          <div *ngFor="let group of faqInfoShow; let i=index;" class="accordion" [id]="'accordionTabs' + i">
            <div class="mt-0" id="blockFaq">
              <div class="col my-3">
                <h6 class="fw-900 fs-16px uppercase-font">{{group.Grupo}}</h6>
              </div>
              <div *ngFor="let qa of group.Perguntas; let j=index;" class="accordion-item">
                <h2 class="accordion-header" [id]="'faqlist-' + i + '-' + j">
                  <button title="Título Pergunta" class="accordion-button collapsed" type="button" aria-expanded="false" data-bs-toggle="collapse"
                          [attr.data-bs-target]="'#question-' + i + '-' + j" [attr.aria-controls]="'question-' + i + '-' + j" [innerHTML]="highlightText(qa.Pergunta)">
                  </button>
                </h2>
                <div [id]="'question-' + i + '-' + j" class="accordion-collapse collapse" [attr.data-bs-parent]="'#accordionTabs' + i ">
                  <div class="accordion-body">
                    <p class="mt-3" [innerHTML]="highlightText(qa.Resposta)"></p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-12 mt-5 text-center">
            <p>{{faqStaticInfo.Texto_Rodape}}</p>
          </div>
          <div class="row justify-content-center pt-20">
            <div class="col-lg-6 col-12 text-center align-self-center mb-5 mb-lg-0">
              <h5>{{faqStaticInfo.Titulo_Botao_Apoio}}</h5>
              <p class="fw-600">{{faqStaticInfo.Descricao_Botao_Apoio}}</p>
              <button title="Botão Apoio ao Passageiro" class="btn-custom btn-3 my-lg-3 mb-3" [routerLink]="'/apoio-passageiros'"><span><p class="my-auto fw-600">{{faqStaticInfo.Botao_Apoio}}</p><i class="uil uil-arrow-up-right color-white ms-2"></i></span></button>
            </div>
            <div class="col-lg-6 col-12 text-center align-self-center mb-5 mb-lg-0">
              <h5>{{faqStaticInfo.Titulo_Botao_Contacto}}</h5>
              <p class="fw-600">{{faqStaticInfo.Descricao_Botao_Contacto}}</p>
              <button title="Botão Contactos" class="btn-custom btn-3 my-lg-3 mb-3" [routerLink]="'/contactos'"><span><p class="my-auto fw-600">{{faqStaticInfo.Botao_Contacto}}</p><i class="uil uil-arrow-up-right color-white ms-2"></i></span></button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</main>

